var _Rect, _Path, _Path2, _Circle, _Mask, _G;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Rect, Path, Circle, Mask, G } from "react-native-svg";
var SvgBr = function SvgBr(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none"
  }, props), _Rect || (_Rect = /*#__PURE__*/React.createElement(Rect, {
    width: 28,
    height: 20,
    fill: "#fff",
    rx: 2
  })), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#05AB41",
    d: "M0 0h28v20H0z"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    fill: "#FDD216",
    fillRule: "evenodd",
    d: "M3.531 10.56a.667.667 0 0 1 0-1.12l10.107-6.539a.67.67 0 0 1 .724 0l10.106 6.54a.667.667 0 0 1 0 1.119L14.362 17.1a.67.67 0 0 1-.724 0z",
    clipRule: "evenodd"
  })), _Circle || (_Circle = /*#__PURE__*/React.createElement(Circle, {
    cx: 14,
    cy: 10,
    r: 4.667,
    fill: "#053087"
  })), _Mask || (_Mask = /*#__PURE__*/React.createElement(Mask, {
    id: "a",
    width: 10,
    height: 10,
    x: 9,
    y: 5,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Circle, {
    cx: 14,
    cy: 10,
    r: 4.667,
    fill: "#fff"
  }))), _G || (_G = /*#__PURE__*/React.createElement(G, {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement(Path, {
    stroke: "#fff",
    strokeLinecap: "square",
    strokeWidth: 1.333,
    d: "M8.78 8.78c.733-.593 3.097-.031 5.304.558 2.207.588 4.509 1.822 5.095 2.546"
  }))));
};
export default SvgBr;